import { Box, Flex, Heading, Image, ScrollArea, Text } from "@chakra-ui/react";
import Header from "../utils/header";
import Footer from "../utils/footer";
import { Offers } from "../utils/utils";
import image1 from "../images/design/Tampak Depan.jpg";
import image2 from "../images/design/Tampak Samping 2.jpg";
import image3 from "../images/design/Tampak Samping.jpg";
import image4 from "../images/image4.png";
import image5 from "../images/consticons.png";

export default function Showroom() {
    return(
        <Box bgImage={`url(${image5})`}>
            <Box bgColor={"whiteAlpha.800"}>
                <Header/>
                <Box px={{base:'6', lg:'20'}}>
                    <Offers images={[]}/>
                    <Box>
                        <Heading
                            textAlign="center" 
                            py={15}
                            color={"blue.500"} 
                            textStyle={"2xl"}
                            fontWeight={"bolder"}
                        >
                            Our Design
                        </Heading>
                        <Box bgImage={`url(${image4})`} my={5} borderRadius={20}>
                            <Box bg={"blue.800/98"} py={10} px={2} borderRadius={20}>
                                <Text color={"gray.100"} mt={2} ml={10} textStyle={"xl"} fontWeight={"bold"}>Type A</Text>
                                <ScrollArea.Root direction="ltr" maxW="100%">
                                    <ScrollArea.Viewport>
                                        <ScrollArea.Content py="4">
                                            <Flex flexWrap={"nowrap"} justify={"space-around"} gap={2}>
                                                { [image1,image2,image3].map(item => (
                                                        <Image src={item} w={{base:"100%",md:'50%',lg:"33%"}}/>
                                                    ))
                                                }
                                            </Flex>
                                        </ScrollArea.Content>
                                    </ScrollArea.Viewport>
                                    <ScrollArea.Scrollbar orientation="horizontal">
                                        <ScrollArea.Thumb />
                                    </ScrollArea.Scrollbar >
                                    <ScrollArea.Corner />
                                </ScrollArea.Root>
                                {/* <ReadDesign design={design1}/> */}
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Footer/>
            </Box>
        </Box>
    );
}